module.exports = __webpack_public_path__ + "static/media/logo_assemblea_legislativa.a5e2980c.png";